<mat-card appearance="outlined" class="card-primary iframe-card">
  <ngx-skeleton-loader
    animation="progress"
    [theme]="{ width: '260px', height: '30px' }"
    count="1"
    appearance="line"></ngx-skeleton-loader>
  <ngx-skeleton-loader
    animation="progress"
    [theme]="{ width: '100%', height: 'calc(100vh - 200px)' }"
    count="1"
    appearance="line"></ngx-skeleton-loader>
</mat-card>
